import React from "react";
import imagemAparelhos from "../../img/imagem-aparelhos.jpg";
import imagemRespiratorios from "../../img/imagem-respiratorios.jpg";
import imagemHomeCare from "../../img/imagem-home-care.jpg";

import imagemCpap from "../../img/cpapservice.jpg";
import imagemOxigenio from "../../img/oxigenoterapiaservice.jpg";
import imagemViaResp from "../../img/via-respiratoria.jpg";

import { useTheme } from "../../contexts/ThemeContext";
import { CITIES_DATA } from "../../data/citiesData";
import { useParams } from "react-router-dom";

const citiesArray = Object.values(CITIES_DATA);

const getCitiesByService = (cities, serviceKey) =>
  cities.filter(city => city[serviceKey] === true);

const Services = ({ onSelectService }) => {
  const { domains } = useTheme();
  const { id } = useParams();

  const isCityPage = !!id;

  const handleClick = (service) => {
    if (isCityPage && onSelectService) {
      onSelectService(prev =>
        prev === service.serviceKey ? null : service.serviceKey
      );
    } else {
      window.location.href = service.link;
    }
  };

  // 🔥 SERVICES DA HOME
  const homeServices = [
    {
      title: "Aparelhos Auditivos",
      link: domains.auditivo,
      linkText: "clique aqui e confira →",
      description: "Não deixe que a perda auditiva limite a sua vida.",
      imageUrl: imagemAparelhos,
      gradient: "linear-gradient(to top, rgba(107,33,168,0.9), transparent)",
      color: "#F982FF",
      serviceKey: "aud",
    },
    {
      title: "Equipamentos Respiratórios",
      link: domains.respiratorio,
      linkText: "clique aqui e confira →",
      description: "Durma utilizando nossos equipamentos originais.",
      imageUrl: imagemRespiratorios,
      gradient: "linear-gradient(to top, rgba(22,163,74,0.9), transparent)",
      color: "#9FFF82",
      serviceKey: "cpap",
    },
    {
      title: "Home Care",
      link: domains.homecare,
      linkText: "clique aqui e confira →",
      description: "Cuide da sua saúde sem precisar sair de casa.",
      imageUrl: imagemHomeCare,
      gradient: "linear-gradient(to top, rgba(12,74,110,0.9), transparent)",
      color: "#82C7FF",
      serviceKey: "home",
    },
  ];

  // 🔥 SERVICES DAS CIDADES
  const cityServices = [
  {
    title: "CPAPs",
    link: domains.respiratorio,
    linkText: "clique aqui e confira →",
    description:
      "Durma aliviado utilizando nossos equipamentos originais e de última geração",
    imageUrl: imagemCpap,
    serviceKey: "cpap",
    gradient:
      "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.6) 40%, rgba(0,0,0,0.2) 70%, transparent 100%)",
    color: "#ffffff",
  },
  {
    title: "Oxigenoterapia",
    link: domains.respiratorio,
    linkText: "clique aqui e confira →",
    description: "Tratamentos completos para suporte respiratório",
    imageUrl: imagemOxigenio,
    serviceKey: "respi",
    gradient:
      "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.6) 40%, rgba(0,0,0,0.2) 70%, transparent 100%)",
    color: "#ffffff",
  },
  {
    title: "Tratamento de Via Respiratória",
    link: domains.respiratorio,
    linkText: "clique aqui e confira →",
    description: "Cuide da sua saúde sem precisar sair de casa",
    imageUrl: imagemViaResp,
    serviceKey: "trat",
    gradient:
      "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.6) 40%, rgba(0,0,0,0.2) 70%, transparent 100%)",
    color: "#ffffff",
  },
];

  const services = isCityPage ? cityServices : homeServices;

  return (
   <section className="max-w-7xl mx-auto grid md:grid-cols-3 gap-4 mb-16 mt-24">
  {services.map((service, index) => {
    const CardContent = (
      <>
        {/* imagem */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${service.imageUrl})`,
          }}
        />

        {/* gradient ORIGINAL */}
        <div
          className="absolute inset-x-0 bottom-0 h-2/5 group-hover:h-3/4 transition-all"
          style={{ background: service.gradient }}
        />

        {/* content */}
        <div className="absolute bottom-0 text-white p-12">
          <h2 className="text-lg font-bold mb-3">
            {service.title}
          </h2>

          <p
            className="text-sm hover:underline"
            style={{ color: service.color }}
          >
            {service.linkText}
          </p>

          <p className="text-xs text-gray-300 mt-4">
            {service.description}
          </p>
        </div>
      </>
    );

    // 🔥 SE FOR PÁGINA DA CIDADE → NÃO USA LINK
    if (isCityPage) {
      return (
        <div
          key={index}
          onClick={() =>
            onSelectService &&
            onSelectService(prev =>
              prev === service.serviceKey ? null : service.serviceKey
            )
          }
          className="relative rounded-2xl overflow-hidden shadow-lg group hover:scale-[1.02] transition-transform h-[550px] block m-4 sm:m-0 cursor-pointer"
        >
          {CardContent}
        </div>
      );
    }

    // 🔥 SE FOR HOME → MANTÉM LINK ORIGINAL
    return (
      <a
        key={index}
        href={service.link}
        className="relative rounded-2xl overflow-hidden shadow-lg group hover:scale-[1.02] transition-transform h-[550px] block m-4 sm:m-0"
      >
        {CardContent}
      </a>
    );
  })}
</section>
  );
};

export default Services;